import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconShoe = props => {
  if (props.id !== "_svgiconshoe") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M17.586 36.452h-2.323a.721.721 0 01-.719-.782c.004-.047.09-1.337-.205-7.839-.18-3.958-.942-5.604-1.555-6.927-.415-.894-.772-1.665-.784-2.813-.012-1.195.51-2.634 1.551-4.278a18.086 18.086 0 011.526-2.068.721.721 0 01.943-.123c3.076 2.06 5.34 6.017 7.337 9.507 1.393 2.434 2.708 4.733 3.798 5.33.66.361 1.199.545 1.6.545.381 0 .574-.167.842-.398.267-.23.598-.517 1.097-.517h.025c.843.017 3.084.062 4.945 1.61 2 1.663 1.232 5.404.464 6.635-.591.948-2.07 2.077-5.759 2.077-1.619 0-3.032-.233-3.715-.464-2.204-.745-4.442-5.972-4.868-7.013-1.965-4.795-2.975-5.054-3.017-5.063a.338.338 0 00-.066-.008c-.025 0-.039 0-.072.035-.066.069-.391.492-.325 2.089.141 3.373.002 9.697 0 9.76a.72.72 0 01-.72.705" fill="#384048" fillRule="evenodd" /></svg>;
};

SvgIconShoe.displayName = "_svgiconshoe";
SvgIconShoe.propTypes = {
  id: PropTypes.string
};
SvgIconShoe.defaultProps = {
  id: ''
};
export default SvgIconShoe;